"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
var _default = exports.default = function _default(_ref) {
  var cdnBaseUrl = _ref.cdnBaseUrl,
    cdnLocalBaseUrl = _ref.cdnLocalBaseUrl,
    cdnVirtualPath = _ref.cdnVirtualPath;
  var isLocal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isLocal) return cdnLocalBaseUrl ? cdnLocalBaseUrl : _constants.CDN_LOCAL_URL;
  var path = "/".concat(cdnVirtualPath).replace('//', '/');
  return "".concat(cdnBaseUrl || _constants.CDN_BASE_URL).concat(path);
};